import toast from "react-hot-toast";
import { axiosInstance } from "../components/lib/axios";


export const getAboutUs = async () => {
    try {
        const res = await axiosInstance.get(`/aboutus`)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}
